module.exports = __webpack_public_path__ + "img/qrcode_page_bottom.cfc6d88c.png";